var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"signatureCanvas",staticClass:"signature mb-2"}),_vm._t("validation"),_c('div',[_c('button',{staticClass:"btn text-footer-color",on:{"click":_vm.clear}},[_vm._v("Clear")]),_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }